import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";
import {MatCheckbox} from "@angular/material/checkbox";
import {FormsModule} from "@angular/forms";


@Component({
    selector: 'alert-dialog',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['./alert-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatButton,
        MatCheckbox,
        FormsModule
    ]
})
export class AlertDialog implements OnInit {
    protected title: string
    protected body: string
    protected successButton: string
    protected cancelButton: string
    protected checkboxLabel?: string
    protected checkboxChecked: boolean

    constructor(public dialogRef: MatDialogRef<void>, @Inject(MAT_DIALOG_DATA) public data: {
        title: string,
        body: string,
        successButton: string,
        cancelButton?: string,
        checkboxLabel?: string,
        checkboxChecked?: boolean
    }) {
        this.title = data.title
        this.body = data.body
        this.successButton = data.successButton
        this.cancelButton = data.cancelButton
        this.checkboxLabel = data.checkboxLabel
        this.checkboxChecked = !!data.checkboxChecked
    }

    ngOnInit(): void {
    }

    onSuccessClick(): void {
        this.dialogRef.close({success: true, dontShowAgain: this.checkboxChecked});
    }

    onCancelClick(): void {
        this.dialogRef.close({success: false, dontShowAgain: this.checkboxChecked});
    }
}
